import { useState, type FC, type ReactNode } from 'react';
import { useRpmActivity } from 'infrastructure/hooks/rpm';
import useUser from 'utils/useUser';
import classNames from 'classnames';

import s from './styles.module.scss';
import { PAGE_SIZE } from '../../constants';

import type { IRpmPatientActivity } from 'infrastructure/interfaces/i-rpm-patient-activity';

type RenderFnProps = {
  page: number;
  setPage: (n: number) => void;
  activity: IRpmPatientActivity | undefined;
  loading: boolean;
};
type RenderFn = (pops: RenderFnProps) => ReactNode;

interface ExpandContainerProps {
  patientGuid: string;
  average: ReactNode;
  table: RenderFn;
  info: ReactNode;
  pagination: RenderFn;
  endTime: number;
  startTime: number;
}

const ExpandContainer: FC<ExpandContainerProps> = ({
  patientGuid,
  average,
  table,
  info,
  endTime,
  startTime,
  pagination,
}) => {
  const [page, setPage] = useState(1);
  const { isCriticalOrAtRiskAlertingRole, isMedicalAssistantRole } = useUser();
  const { activity, isLoading, isFetching } = useRpmActivity(
    {
      reviewed: false,
      patientGuid,
      applySpecialFilter: isCriticalOrAtRiskAlertingRole === true,
      startTime,
      endTime,
      skipMACheck: isMedicalAssistantRole || undefined,
      page,
      applyLinkedCalls: true,
      criticalTypeSort: 'ASC',
    },
    PAGE_SIZE,
  );

  return (
    <div
      className={classNames(s.wrapper, {
        [s['one-row']]: isCriticalOrAtRiskAlertingRole,
      })}
    >
      <div className={s.average}>{average}</div>
      <div className={s.table}>
        {table({ page, setPage, activity, loading: isFetching || isLoading })}
      </div>
      <div className={s.info}>{info}</div>
      <div className={s.pagination}>
        {pagination({
          page,
          setPage,
          activity,
          loading: isFetching || isLoading,
        })}
      </div>
    </div>
  );
};
export default ExpandContainer;
